/**
 * Journey-based product breadcrumbs.
 * Remembers the last collection the shopper visited and uses it on the
 * product page when Shopify has no collection URL context.
 */
(function () {
  var STORAGE_KEY = 'bb_ref_collection';

  function safeParse(json) {
    try {
      return JSON.parse(json);
    } catch (e) {
      return null;
    }
  }

  function saveCollection(data) {
    if (!data || !data.handle) return;
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function readSavedCollection() {
    try {
      return safeParse(sessionStorage.getItem(STORAGE_KEY));
    } catch (e) {
      return null;
    }
  }

  function collectionFromReferrer(allowedHandles) {
    var ref = document.referrer || '';
    if (!ref) return null;
    var match = ref.match(/\/collections\/([^\/\?#]+)/i);
    if (!match || !match[1]) return null;
    var handle = decodeURIComponent(match[1]);
    if (handle === 'all') return null;
    if (allowedHandles && allowedHandles.indexOf(handle) === -1) return null;
    return handle;
  }

  function markReady(crumb) {
    if (!crumb) return;
    crumb.classList.remove('is-pending');
    crumb.setAttribute('data-bb-ready', 'true');
    var sep = crumb.previousElementSibling;
    if (sep && sep.hasAttribute('data-bb-collection-sep')) {
      sep.classList.remove('is-pending');
    }
  }

  function initCollectionPage() {
    var el = document.querySelector('[data-bb-save-collection]');
    if (!el) return;
    saveCollection({
      handle: el.getAttribute('data-handle'),
      title: el.getAttribute('data-title'),
      url: el.getAttribute('data-url'),
    });
  }

  function initProductPage() {
    var crumb = document.querySelector('[data-bb-collection-crumb]');
    if (!crumb) return;
    if (crumb.getAttribute('data-has-url-collection') === 'true') {
      markReady(crumb);
      return;
    }

    var jsonEl = document.getElementById('bb-product-collections-json');
    var list = jsonEl ? safeParse(jsonEl.textContent) : null;
    var byHandle = {};
    var handles = [];

    if (Array.isArray(list)) {
      for (var i = 0; i < list.length; i++) {
        if (!list[i] || !list[i].handle) continue;
        byHandle[list[i].handle] = list[i];
        handles.push(list[i].handle);
      }
    }

    var chosen = null;
    var saved = readSavedCollection();
    if (saved && saved.handle && byHandle[saved.handle]) {
      chosen = byHandle[saved.handle];
    }

    if (!chosen) {
      var refHandle = collectionFromReferrer(handles);
      if (refHandle && byHandle[refHandle]) {
        chosen = byHandle[refHandle];
      }
    }

    var link = crumb.querySelector('a');
    if (!link) {
      link = document.createElement('a');
      crumb.appendChild(link);
    }

    if (chosen) {
      link.href = chosen.url;
      link.textContent = chosen.title;
      link.removeAttribute('data-bb-fallback');
    } else {
      var fallbackTitle = link.getAttribute('data-fallback-title');
      var fallbackUrl = link.getAttribute('data-fallback-url');
      if (fallbackTitle) link.textContent = fallbackTitle;
      if (fallbackUrl) link.href = fallbackUrl;
    }

    markReady(crumb);
  }

  window.BBBreadcrumbJourney = {
    initCollectionPage: initCollectionPage,
    initProductPage: initProductPage,
  };

  initCollectionPage();
  initProductPage();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCollectionPage();
      initProductPage();
    });
  }
})();
